import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { Routes, ModalRoutes, USE_MODAL_QUERY_PARAM } from '../../routes';
import ModalWrapper from '../modals/ModalWrapper';

import './RegistrationPromptModal.scss';

const RegistrationPromptModal = (): React.ReactElement => {
  const history = useHistory();
  const { id } = useParams() as { id: string };

  const editIslandUrl = generatePath(ModalRoutes.Island.Edit, {
    id,
  }).concat(`?${USE_MODAL_QUERY_PARAM}`);

  const onRegister = () => {
    // Register, with return to edit island
    const registrationUrl = Routes.User.New
      .concat(`?redirectTo=${encodeURIComponent(editIslandUrl)}`);

    history.push(registrationUrl);
  };

  // Return to the island
  const onCancel = () => {
    history.push(Routes.Islands.View, {
      id,
    });
  };

  /**
   * Send them to Login. Parents and Educators have their own default redirects, no
   * need to set a return to parameter in this case.
   */
  const onExistingAccount = () => {
    history.push(Routes.Session.New);
  };

  return (
    <ModalWrapper headerTitle="Want to save your Island?" onClose={onCancel}>
      <div className="registration-prompt">
        <div className="actions">
          <button
            className="button primary"
            type="button"
            onClick={onRegister}
          >
            Create Account
          </button>

          <button
            className="button primary"
            type="button"
            onClick={onCancel}
          >
            Back to Games
          </button>
        </div>

        <div className="info">
          <button
            type="button"
            className="button"
            onClick={onExistingAccount}
            title="Login using an existing Account"
          >
            Existing Account?
          </button>

        </div>
      </div>
    </ModalWrapper>
  );
};

export default RegistrationPromptModal;
